/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseQueryFn, MutationDefinition, QueryDefinition } from '@reduxjs/toolkit/query';
import { useGetCompaniesWithJoinQuery } from 'features/company/services';
import { useGetWebsitesWithJoinQuery } from 'features/website/services';
import { UseMutation, UseQuery } from 'node_modules/@reduxjs/toolkit/dist/query/react/buildHooks';
import { PaginatedResponse } from 'types/dtos';
import { TableQueryIdentifier } from 'types/table-settings';

import { useGetTerminalsWithJoinQuery } from 'features/terminal/services';
import { useGetCompanyOwnersWithJoinQuery } from 'features/company-owner/services';
import { useGetEndUsersQuery } from 'features/endUser/services';
import { useGetPlacesWithJoinQuery } from 'features/place/services';
import { useGetProductsWithJoinQuery } from 'features/product/services';
import { useGetProductCategoriesQuery } from 'features/product-category/services';
import { useGetOrdersWithJoinQuery } from 'features/orders/services';
import { useGetNestedProductsWithJoinQuery } from 'features/nested-product/services';
import { useGetNestedProductCategoriesQuery } from 'features/nested-product-category/services';
import { useGetPromotionsQuery } from 'features/promotion/services';

type TableQueryActions = {
    fetchQuery: UseQuery<QueryDefinition<any, BaseQueryFn, string, PaginatedResponse<any>, string>>;
    deleteMutation?: UseMutation<MutationDefinition<string, BaseQueryFn, string, void, string>>;
};

export const tableQueries = (): Record<TableQueryIdentifier, TableQueryActions> => ({
    websites: {
        fetchQuery: useGetWebsitesWithJoinQuery,
        // deleteMutation: useDeleteWebsiteMutation,
    },
    companies: {
        fetchQuery: useGetCompaniesWithJoinQuery,
        // deleteMutation: useDeleteCompanyMutation,
    },
    terminals: {
        fetchQuery: useGetTerminalsWithJoinQuery,
        // deleteMutation: useDeleteTerminalMutation,
    },
    companyOwners: {
        fetchQuery: useGetCompanyOwnersWithJoinQuery,
        // deleteMutation: useDeleteCompanyOwnerMutation,
    },
    endUsers: {
        fetchQuery: useGetEndUsersQuery,
    },
    places: {
        fetchQuery: useGetPlacesWithJoinQuery,
    },
    products: {
        fetchQuery: useGetProductsWithJoinQuery,
    },
    productCategories: {
        fetchQuery: useGetProductCategoriesQuery,
    },
    orders: {
        fetchQuery: useGetOrdersWithJoinQuery,
    },
    nestedProducts: {
        fetchQuery: useGetNestedProductsWithJoinQuery,
    },
    nestedProductsCategories: {
        fetchQuery: useGetNestedProductCategoriesQuery,
    },
    promotions: {
        fetchQuery: useGetPromotionsQuery,
    },
});
